import React from 'react';
import { FiTool, FiClock } from 'react-icons/fi';
import Lottie from 'lottie-react';
import maintenanceAnimation from '../../assets/animations/Maintenance.json';

const MaintenancePage = ({ data }) => {
  const message = data?.message;
  const endTime = data?.ends_at;
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col items-center justify-center p-4 text-center relative">
      <div className="absolute top-1/3 transform -translate-y-1/2">
        <Lottie
          animationData={maintenanceAnimation}
          style={{ width: '450px', height: '450px' }}
          loop={true}
        />
      </div>
      
      <div className="relative z-10 mt-48">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
          الموقع تحت الصيانة
        </h1>
        
        <p className="text-xl text-gray-600 dark:text-gray-300 mb-8 max-w-md mx-auto">
          {message || 'نعتذر عن الإزعاج، نحن نقوم ببعض التحسينات. سنعود قريباً!'}
        </p>
      </div>
      
      <div className="relative z-10">
        {endTime !== null && endTime !== '' && (
          <div className="text-lg text-gray-700 dark:text-gray-300 bg-white/30 dark:bg-gray-800/30 backdrop-blur-sm py-4 px-8 rounded-lg max-w-lg mx-auto">
            <div className="mb-2">وقت انتهاء الصيانة المتوقع:</div>
            <span className="font-medium text-xl">
              {endTime ? new Date(endTime).toLocaleString('en-US', {
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: true
              }) : ''}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MaintenancePage;
